import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as dayjs from 'dayjs';
import { of, switchMap, timer } from 'rxjs';

export function asyncDateGroupValidate(dateGroup: AbstractControl): ValidationErrors | null {
  return timer(this.DEBOUNCE_TIME_MS).pipe(
    switchMap(() => {
      return of(checkDOBbeforeDOD(dateGroup));
    }),
  );
}

export function checkDOBbeforeDOD(dateGroup: AbstractControl): ValidationErrors | null {
  const dob = dateGroup.get('dob').value;
  const dod = dateGroup.get('dod').value;
  if (dod === '' || dob === '') return null;

  if (dayjs(dob, 'MM/DD/YYYY', true).isValid() && dayjs(dod, 'MM/DD/YYYY', true).isValid()) {
    const dobObj = dayjs(dob, 'MM/DD/YYYY', true);
    const dodObj = dayjs(dod, 'MM/DD/YYYY', true);
    return dobObj <= dodObj ? null : { dodBeforeDobError: 'dod before dob' };
  }
  return { dodBeforeDobError: 'dob or dod invalid' };
}

export function validateDob(control: AbstractControl): ValidationErrors | null {
  return validateDate(control.value);
}

export function validateDod(control: AbstractControl): ValidationErrors | null {
  if (control.value) {
    return validateDate(control.value);
  } else {
    return null;
  }
}

// Validate dates with format: mm/dd/yyyy
export function validateDate(date: string) {
  const isValidDate = date.length === 10 && dayjs(date, 'MM/DD/YYYY', true).isValid();
  const minDate = dayjs('01/01/1900', 'MM/DD/YYYY');
  const dateObj = dayjs(date, 'MM/DD/YYYY');
  return isValidDate && dateObj.isBefore(dayjs()) && dateObj.isAfter(minDate)
    ? null
    : { invalidDateError: 'DATE INVALID' };
}

export function validateDOBbeforeDOD(dobValue: string, dodValue: string): boolean {
  if (dayjs(dobValue, 'MM/DD/YYYY').isValid() && dayjs(dodValue, 'MM/DD/YYYY').isValid()) {
    const dobObj = dayjs(dobValue, 'MM/DD/YYYY');
    const dodObj = dayjs(dodValue, 'MM/DD/YYYY');
    if (dobObj <= dodObj) {
      return true;
    }
    return false;
  }
  return null;
}
